// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .distributor-form {
    padding-top: 10px;
    display: flex;
    flex-direction: column;
    justify-items: center;
    align-items: center;
    width:100vw;
    background-color: rgba(0, 0, 0, 0.1);

}


.distributor-form img{
    width:50vw;
    border-radius: 10px;
    margin-bottom: 20px;
}

.form {
    width: 50vw;
    display: flex;
    flex-direction: column;
    text-align: left;
   
    
    
    
}

.form button{
    width:120px;
    height:50px;
    background-color: #e42727;
    border: none;
    font-size: medium;
    color:#fff;
    font-weight: 500;
    
}



.form label {
    font-size: larger;
}


.form input {
    height: 50px;
    font-size: medium;
   
    
}


fieldset {
    display: flex;
    flex-direction: column;
}

.radio p {
    font-size: large;
}



.options {
    display: flex;
    flex-direction: column;

}

.option {
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    font-size: medium;
}

.option label {
    margin-left: 20px;
}

.option input[type='radio'] {
    width: 20px;
    border-color:red;
}

.radio{
    width:100%;
}

.text-question p {
    font-size: large;
}

.text-question input {
    width: 80%;
    
}

.text-input,.radio,.text-question{
    display: flex;
    flex-direction: column;
    background-color:#fff;
    width:95%;
    margin-bottom: 10px;
    border-radius: 10px;
    padding:20px;
    
    
}

.text-input input,.text-question input{
    border-top: none;
    border-left:none;
    border-right:none;
   
    
    
}


.previous-buttons{
    display: flex;
}
.previous-buttons button{
    margin-right:20px;
}

.number-field input{
     width:80%;
}

.error-message{
    color:red;
}
.success-note{
    color:green;
}


.text-input span{
    color:red;
}


.text-block {
    
    background-color: #fff;
    margin: auto;
    width: 50vw;
    border-radius: 10px;
    text-align: left;
    margin-bottom: 20px;
    
}

.text-block h1 {
    padding:10px;
    font-size: 2.5rem;
    
    color: #333;
    
    margin-bottom: 20px;
    font-weight: 400;
}

.text-block p {
    padding:10px;
    font-size: 1.2rem;
    
    color: #555;
   
    line-height: 1.6;
    
    margin: 0 auto;
    
}

.other-category-input{
    border-top:none;border-left: none;
    border-right: none;
    margin-left: 50px;
    width:80%;
}

.loader {
    position: fixed;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50px;
    height: 50px;
    border: 5px solid rgba(0, 0, 0, 0.1);
    border-top: 5px solid #3498db;
  
    border-radius: 50%;
    animation: spin 1s linear infinite;
    z-index: 1000;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}


@media (max-width: 576px) {
    .distributor-form img {
        width: 90vw;
    }
    .text-block{
        width:90vw;
    }

    .form {
        width: 90vw;
    }

    .form button {
        width: 100px;
        height: 40px;
    }

    label {
        font-size: medium;
    }

    .form input {
        height: 40px;
        font-size: small;
    }

    .radio p {
        font-size: medium;
    }

    .option input[type='radio'] {
        width: 18px;
    }

    .text-question p {
        font-size: medium;
    }

    .text-question input {
        width: 90%;
    }

    .previous-buttons {
        flex-direction: column;
    }

    button {
        margin-right: 0;
        margin-bottom: 10px;
    }

    .number-field button{
        margin-top:10px;
        font-size: small;
    }
         .text-input,
         .radio,
         .text-question {
             display: flex;
             flex-direction: column;
             background-color: #fff;
             width: 90%;
             margin-bottom: 10px;
             border-radius: 10px;
             padding: 20px;
    
    
         }
}




@media (min-width: 577px) and (max-width: 768px) {
    .distributor-form{
        height:100%;
    }
    .distributor-form img {
        width: 70vw;
    }
    .text-block{
        width:70vw;
    }
    .form {
        width: 70vw;
    }

    .form button {
        width: 110px;
        height: 45px;
    }

    label {
        font-size: larger;
    }

    .form input {
        height: 45px;
        font-size: medium;
    }

    .radio p {
        font-size: large;
    }

    .option input[type='radio'] {
        width: 19px;
    }

    .text-question p {
        font-size: large;
    }

    .text-question input {
        width: 85%;
    }

    .previous-buttons {
        flex-direction: row;
    }

    button {
        margin-right: 20px;
    }
        .text-input,
        .radio,
        .text-question {
            display: flex;
            flex-direction: column;
            background-color: #fff;
            width: 90%;
            margin-bottom: 10px;
            border-radius: 10px;
            padding: 20px;
    
    
        }
        
}


@media (min-width: 769px) and (max-width: 1024px) {
    .distributor-form {
            height: 100%;
    }
    .distributor-form img {
        width: 60vw;
    }
    .text-block{
        width:60vw;
    }

    .form {
        width: 60vw;
    }

    .form button {
        width: 115px;
        height: 47px;
    }

    label {
        font-size: larger;
    }

    .form input {
        height: 47px;
        font-size: medium;
    }

    .radio p {
        font-size: large;
    }

    .option input[type='radio'] {
        width: 19px;
    }

    .text-question p {
        font-size: large;
    }

    .text-question input {
        width: 85%;
    }

    .previous-buttons {
        flex-direction: row;
    }

    button {
        margin-right: 20px;
    }
        .text-input,
        .radio,
        .text-question {
            display: flex;
            flex-direction: column;
            background-color: #fff;
            width: 95%;
            margin-bottom: 10px;
            border-radius: 10px;
            padding: 20px;
    
    
        }
} 
/*
*/`, "",{"version":3,"sources":["webpack://./src/Styles/Distributor/Form.css"],"names":[],"mappings":"CAAC;IACG,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,oCAAoC;;AAExC;;;AAGA;IACI,UAAU;IACV,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,gBAAgB;;;;;AAKpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,gBAAgB;;AAEpB;;;;AAIA;IACI,iBAAiB;AACrB;;;AAGA;IACI,YAAY;IACZ,iBAAiB;;;AAGrB;;;AAGA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;;;AAIA;IACI,aAAa;IACb,sBAAsB;;AAE1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;;AAEd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;;;AAGhB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;;;;AAIrB;;;AAGA;IACI,aAAa;AACjB;AACA;IACI,iBAAiB;AACrB;;AAEA;KACK,SAAS;AACd;;AAEA;IACI,SAAS;AACb;AACA;IACI,WAAW;AACf;;;AAGA;IACI,SAAS;AACb;;;AAGA;;IAEI,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;;AAEvB;;AAEA;IACI,YAAY;IACZ,iBAAiB;;IAEjB,WAAW;;IAEX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;;IAEjB,WAAW;;IAEX,gBAAgB;;IAEhB,cAAc;;AAElB;;AAEA;IACI,eAAe,CAAC,iBAAiB;IACjC,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,6BAA6B;;IAE7B,kBAAkB;IAClB,kCAAkC;IAClC,aAAa;AACjB;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;;AAGA;IACI;QACI,WAAW;IACf;IACA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;SACK;;;aAGI,aAAa;aACb,sBAAsB;aACtB,sBAAsB;aACtB,UAAU;aACV,mBAAmB;aACnB,mBAAmB;aACnB,aAAa;;;SAGjB;AACT;;;;;AAKA;IACI;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,UAAU;IACd;IACA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;QACI;;;YAGI,aAAa;YACb,sBAAsB;YACtB,sBAAsB;YACtB,UAAU;YACV,mBAAmB;YACnB,mBAAmB;YACnB,aAAa;;;QAGjB;;AAER;;;AAGA;IACI;YACQ,YAAY;IACpB;IACA;QACI,WAAW;IACf;IACA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;QACI;;;YAGI,aAAa;YACb,sBAAsB;YACtB,sBAAsB;YACtB,UAAU;YACV,mBAAmB;YACnB,mBAAmB;YACnB,aAAa;;;QAGjB;AACR;AACA;CACC","sourcesContent":[" .distributor-form {\n    padding-top: 10px;\n    display: flex;\n    flex-direction: column;\n    justify-items: center;\n    align-items: center;\n    width:100vw;\n    background-color: rgba(0, 0, 0, 0.1);\n\n}\n\n\n.distributor-form img{\n    width:50vw;\n    border-radius: 10px;\n    margin-bottom: 20px;\n}\n\n.form {\n    width: 50vw;\n    display: flex;\n    flex-direction: column;\n    text-align: left;\n   \n    \n    \n    \n}\n\n.form button{\n    width:120px;\n    height:50px;\n    background-color: #e42727;\n    border: none;\n    font-size: medium;\n    color:#fff;\n    font-weight: 500;\n    \n}\n\n\n\n.form label {\n    font-size: larger;\n}\n\n\n.form input {\n    height: 50px;\n    font-size: medium;\n   \n    \n}\n\n\nfieldset {\n    display: flex;\n    flex-direction: column;\n}\n\n.radio p {\n    font-size: large;\n}\n\n\n\n.options {\n    display: flex;\n    flex-direction: column;\n\n}\n\n.option {\n    display: flex;\n    flex-direction: row;\n    justify-content: left;\n    align-items: center;\n    font-size: medium;\n}\n\n.option label {\n    margin-left: 20px;\n}\n\n.option input[type='radio'] {\n    width: 20px;\n    border-color:red;\n}\n\n.radio{\n    width:100%;\n}\n\n.text-question p {\n    font-size: large;\n}\n\n.text-question input {\n    width: 80%;\n    \n}\n\n.text-input,.radio,.text-question{\n    display: flex;\n    flex-direction: column;\n    background-color:#fff;\n    width:95%;\n    margin-bottom: 10px;\n    border-radius: 10px;\n    padding:20px;\n    \n    \n}\n\n.text-input input,.text-question input{\n    border-top: none;\n    border-left:none;\n    border-right:none;\n   \n    \n    \n}\n\n\n.previous-buttons{\n    display: flex;\n}\n.previous-buttons button{\n    margin-right:20px;\n}\n\n.number-field input{\n     width:80%;\n}\n\n.error-message{\n    color:red;\n}\n.success-note{\n    color:green;\n}\n\n\n.text-input span{\n    color:red;\n}\n\n\n.text-block {\n    \n    background-color: #fff;\n    margin: auto;\n    width: 50vw;\n    border-radius: 10px;\n    text-align: left;\n    margin-bottom: 20px;\n    \n}\n\n.text-block h1 {\n    padding:10px;\n    font-size: 2.5rem;\n    \n    color: #333;\n    \n    margin-bottom: 20px;\n    font-weight: 400;\n}\n\n.text-block p {\n    padding:10px;\n    font-size: 1.2rem;\n    \n    color: #555;\n   \n    line-height: 1.6;\n    \n    margin: 0 auto;\n    \n}\n\n.other-category-input{\n    border-top:none;border-left: none;\n    border-right: none;\n    margin-left: 50px;\n    width:80%;\n}\n\n.loader {\n    position: fixed;\n    top: 40%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 50px;\n    height: 50px;\n    border: 5px solid rgba(0, 0, 0, 0.1);\n    border-top: 5px solid #3498db;\n  \n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n    z-index: 1000;\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n\n@media (max-width: 576px) {\n    .distributor-form img {\n        width: 90vw;\n    }\n    .text-block{\n        width:90vw;\n    }\n\n    .form {\n        width: 90vw;\n    }\n\n    .form button {\n        width: 100px;\n        height: 40px;\n    }\n\n    label {\n        font-size: medium;\n    }\n\n    .form input {\n        height: 40px;\n        font-size: small;\n    }\n\n    .radio p {\n        font-size: medium;\n    }\n\n    .option input[type='radio'] {\n        width: 18px;\n    }\n\n    .text-question p {\n        font-size: medium;\n    }\n\n    .text-question input {\n        width: 90%;\n    }\n\n    .previous-buttons {\n        flex-direction: column;\n    }\n\n    button {\n        margin-right: 0;\n        margin-bottom: 10px;\n    }\n\n    .number-field button{\n        margin-top:10px;\n        font-size: small;\n    }\n         .text-input,\n         .radio,\n         .text-question {\n             display: flex;\n             flex-direction: column;\n             background-color: #fff;\n             width: 90%;\n             margin-bottom: 10px;\n             border-radius: 10px;\n             padding: 20px;\n    \n    \n         }\n}\n\n\n\n\n@media (min-width: 577px) and (max-width: 768px) {\n    .distributor-form{\n        height:100%;\n    }\n    .distributor-form img {\n        width: 70vw;\n    }\n    .text-block{\n        width:70vw;\n    }\n    .form {\n        width: 70vw;\n    }\n\n    .form button {\n        width: 110px;\n        height: 45px;\n    }\n\n    label {\n        font-size: larger;\n    }\n\n    .form input {\n        height: 45px;\n        font-size: medium;\n    }\n\n    .radio p {\n        font-size: large;\n    }\n\n    .option input[type='radio'] {\n        width: 19px;\n    }\n\n    .text-question p {\n        font-size: large;\n    }\n\n    .text-question input {\n        width: 85%;\n    }\n\n    .previous-buttons {\n        flex-direction: row;\n    }\n\n    button {\n        margin-right: 20px;\n    }\n        .text-input,\n        .radio,\n        .text-question {\n            display: flex;\n            flex-direction: column;\n            background-color: #fff;\n            width: 90%;\n            margin-bottom: 10px;\n            border-radius: 10px;\n            padding: 20px;\n    \n    \n        }\n        \n}\n\n\n@media (min-width: 769px) and (max-width: 1024px) {\n    .distributor-form {\n            height: 100%;\n    }\n    .distributor-form img {\n        width: 60vw;\n    }\n    .text-block{\n        width:60vw;\n    }\n\n    .form {\n        width: 60vw;\n    }\n\n    .form button {\n        width: 115px;\n        height: 47px;\n    }\n\n    label {\n        font-size: larger;\n    }\n\n    .form input {\n        height: 47px;\n        font-size: medium;\n    }\n\n    .radio p {\n        font-size: large;\n    }\n\n    .option input[type='radio'] {\n        width: 19px;\n    }\n\n    .text-question p {\n        font-size: large;\n    }\n\n    .text-question input {\n        width: 85%;\n    }\n\n    .previous-buttons {\n        flex-direction: row;\n    }\n\n    button {\n        margin-right: 20px;\n    }\n        .text-input,\n        .radio,\n        .text-question {\n            display: flex;\n            flex-direction: column;\n            background-color: #fff;\n            width: 95%;\n            margin-bottom: 10px;\n            border-radius: 10px;\n            padding: 20px;\n    \n    \n        }\n} \n/*\n*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
